// This file is generated by a script and should not be modified directly.
const markdown: string = "List of warnings related to the search.\n"
export default markdown
